<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title"
	(eventFired)="headerButtonClick($event)"></admin-header>
<div class="profile-container">
	<!-- Left Section -->
	<div class="left-panel">
		<h2>Personal Information</h2>
		<p>View your personal details and contact information</p>

		<div class="form-row">
			<div class="form-group">
				<label>First Name</label>
				<input [ngModel]="member.firstName" type="text" placeholder="Jude">
			</div>

			<div class="form-group">
				<label>Last Name</label>
				<input type="text" [ngModel]="member.lastName" placeholder="Bellingham">
			</div>
		</div>

		<div class="form-row">
			<div class="form-group">
				<label>Email Address</label>
				<input [ngModel]="member.user.email" type="email" placeholder="heyjude@bcfc.com" readonly>
			</div>

			<div class="form-group">
				<label>Phone Number</label>
				<input type="text" [ngModel]="member.telephoneNumber" placeholder="0121 876463">
			</div>
		</div>
		<div class="form-row">
			<div class="form-group">
				<label>Gender</label>
				<input type="text" [ngModel]="member.gender" placeholder="Male" readonly>
			</div>

			<div class="form-group">
				<label>Date Of Birth</label>
				<input [ngModel]="dob |  date:'dd/MM/yyyy'" placeholder="01/01/1970"
					readonly>
			</div>
		</div>

		<label>Address</label>
		<textarea rows="4" [ngModel]="fullAddress"
			placeholder="123 Business Street, Suite 100&#10;New York, NY 10001&#10;United States"></textarea>
	</div>

	<!-- Right Section -->
	<div class="right-panel">
		<h2>Password & Security</h2>
		<p>Update your password to stay secure</p>

		<label>Current Password</label>
		<div class="password-wrapper">
			<input [(ngModel)]="cp.oldPassword" type="password" placeholder="••••••••">
			<i class="fa fa-eye"></i>
		</div>

		<label>New Password</label>
		<div class="password-wrapper">
			<input [(ngModel)]="cp.password" (input)="checkPasswordStrength()" type="password" placeholder="••••••••">
			<i class="fa fa-eye"></i>
		</div>
		<div class="strength-bar-container">
			<div class="strength-bar" style="width:{{passwordStrength}}%; background-color:{{strengthColor}};">
			</div>
		</div>
		<div class="strength-label" [style.color]="strengthColor">
			{{ strengthLabel }}
		</div>

		<label>Confirm New Password</label>
		<div class="password-wrapper">
			<input [(ngModel)]="cp.confirmPassword" type="password" placeholder="••••••••">
			<i class="fa fa-eye"></i>
		</div>

		<div class="requirements">
			<p><strong>Password Requirements:</strong></p>
			<ul>
				<li>At least 8 characters long</li>
				<li>Include uppercase and lowercase letters</li>
				<li>Include at least one number</li>
				<li>Include at least one special character</li>
			</ul>
		</div>

		<button (click)="handleSubmit($event)" *ngIf="cp.confirmPassword === cp.password && passwordStrength === 100" class="update-btn">
			<i class="fa fa-lock"></i> Update Password
		</button>
		<button *ngIf="cp.confirmPassword !== cp.password || passwordStrength < 100" class="disabled-btn">
			<i class="fa fa-lock"></i> Update Password
		</button>
	</div>
</div>